import { configureStore } from "@reduxjs/toolkit";
import applicationFormReducer from "./applicationFormReducer";
import authReducer from "./authReducer";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    applicationForm: applicationFormReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serialization checks
        ignoredActions: ["auth/login/fulfilled", "auth/checkAuth/fulfilled"],
      },
    }),
});

export default store;
